/* Only use this file temporarily while <Suspense /> is supported in PWA Kit
 * It will add all the icons to the bundle, which will increase the bundle size
 */
import type { FC } from 'react';
import AddToBag from './icon-components/add-to-bag';
import AddToBagAlternative from './icon-components/add-to-bag-alternative';
import AddToRegistry from './icon-components/add-to-registry';
import Chat from './icon-components/chat';
import Check from './icon-components/check';
import ChevronRight from './icon-components/chevron-right';
import Close from './icon-components/close';
import DarkFilledCircle from './icon-components/dark-filled-circle';
import DarkPlay from './icon-components/dark-play';
import Dislike from './icon-components/dislike';
import DropdownArrowClose from './icon-components/dropdown-arrow-close';
import DropdownArrowOpen from './icon-components/dropdown-arrow-open';
import EmptyRoundedStar from './icon-components/empty-rounded-star';
import EmptyStar from './icon-components/empty-star';
import ExpandArrowCircle from './icon-components/expand-arrow-circle';
import { ExternalLink } from './icon-components/external-link';
import Filter from './icon-components/filter';
import Flag from './icon-components/flag';
import FlagFilled from './icon-components/flag-filled';
import Gift from './icon-components/gift';
import HalfEmptyStar from './icon-components/half-empty-star';
import InStorePickup from './icon-components/in-store-pickup';
import Info from './icon-components/info';
import LightFilledCircle from './icon-components/light-filled-circle';
import LightPlay from './icon-components/light-play';
import Like from './icon-components/like';
import LikeFilled from './icon-components/like-filled';
import LoadingWheel from './icon-components/loading-wheel';
import MagnifyingGlassZoomIn from './icon-components/magnifying-glass-zoom-in';
import MagnifyingGlassZoomOut from './icon-components/magnifying-glass-zoom-out';
import Minus from './icon-components/minus';
import NavigationArrowLeft from './icon-components/navigation-arrow-left';
import NavigationArrowRight from './icon-components/navigation-arrow-right';
import { NavigationSlideArrowLeftIcon } from './icon-components/navigation-slide-arrow-left';
import { NavigationSlideArrowRightIcon } from './icon-components/navigation-slide-arrow-right';
import Pencil from './icon-components/pencil';
import Photo from './icon-components/photo';
import Play from './icon-components/play';
import PlayInCircle from './icon-components/play-in-circle';
import Plus from './icon-components/plus';
import PlusCircle from './icon-components/plus-circle';
import ProgressBar from './icon-components/progress-bar';
import RevertedLike from './icon-components/reverted-like';
import RevertedLikeFilled from './icon-components/reverted-like-filled';
import RoundedStar from './icon-components/rounded-star';
import SameDayDelivery from './icon-components/same-day-delivery';
import Search from './icon-components/search';
import Shipping from './icon-components/shipping';
import ShipsFast from './icon-components/ships-fast';
import ShoppingCartCircle from './icon-components/shopping-cart-circle';
import Snail from './icon-components/snail';
import Star from './icon-components/star';
import Store from './icon-components/store';
import Tag from './icon-components/tag';
import TimerCash from './icon-components/timer-cash';
import Triangle from './icon-components/triangle';
import TriangleFilled from './icon-components/triangle-filled';
import Union from './icon-components/union';
import UseMyLocation from './icon-components/use-my-location';
import Video from './icon-components/video';
import VoteUp from './icon-components/voteup';
import Wallet from './icon-components/wallet';
import Warning from './icon-components/warning';
import Whisk from './icon-components/whisk';
import Wishlist from './icon-components/wishlist';
import WishlistFilled from './icon-components/wishlist-filled';
import type { CustomIconProps } from './types';

export const IconsList: Record<string, FC<CustomIconProps>> = {
    'add-to-bag': AddToBag,
    'add-to-bag-alternative': AddToBagAlternative,
    'add-to-registry': AddToRegistry,
    chat: Chat,
    check: Check,
    'chevron-right': ChevronRight,
    close: Close,
    'dark-filled-circle': DarkFilledCircle,
    'dark-play': DarkPlay,
    dislike: Dislike,
    'dropdown-arrow-close': DropdownArrowClose,
    'dropdown-arrow-open': DropdownArrowOpen,
    'empty-rounded-star': EmptyRoundedStar,
    'empty-star': EmptyStar,
    'expand-arrow-circle': ExpandArrowCircle,
    'external-link': ExternalLink,
    'flag-filled': FlagFilled,
    flag: Flag,
    gift: Gift,
    'half-empty-star': HalfEmptyStar,
    'in-store-pickup': InStorePickup,
    'index.ts': Info,
    info: Info,
    'light-filled-circle': LightFilledCircle,
    'light-play': LightPlay,
    'like-filled': LikeFilled,
    like: Like,
    'loading-wheel': LoadingWheel,
    'magnifying-glass-zoom-in': MagnifyingGlassZoomIn,
    'magnifying-glass-zoom-out': MagnifyingGlassZoomOut,
    minus: Minus,
    'navigation-arrow-left': NavigationArrowLeft,
    'navigation-arrow-right': NavigationArrowRight,
    'navigation-slide-arrow-left': NavigationSlideArrowLeftIcon,
    'navigation-slide-arrow-right': NavigationSlideArrowRightIcon,
    pencil: Pencil,
    photo: Photo,
    'play-in-circle': PlayInCircle,
    play: Play,
    'plus-circle': PlusCircle,
    plus: Plus,
    'progress-bar': ProgressBar,
    'reverted-like-filled': RevertedLikeFilled,
    'reverted-like': RevertedLike,
    'rounded-star': RoundedStar,
    'same-day-delivery': SameDayDelivery,
    search: Search,
    shipping: Shipping,
    'ships-fast': ShipsFast,
    'shopping-cart-circle': ShoppingCartCircle,
    snail: Snail,
    star: Star,
    store: Store,
    'timer-cash': TimerCash,
    'triangle-filled': TriangleFilled,
    triangle: Triangle,
    'use-my-location': UseMyLocation,
    video: Video,
    voteup: VoteUp,
    wallet: Wallet,
    warning: Warning,
    whisk: Whisk,
    union: Union,
    tag: Tag,
    filter: Filter,
    wishlist: Wishlist,
    'wishlist-filled': WishlistFilled,
};
